/**
 * Shared input restrictions.
 *
 * Live-filter disallowed characters out of text inputs, declaratively via data
 * attributes so any form can opt in without bespoke JS:
 *   - data-restrict="name"   -> strips digits (names)
 *   - data-restrict="phone"  -> keeps only digits and + ( ) space - (phone numbers)
 *   - data-restrict="email"  -> strips any '@' typed/pasted after the first one
 *
 * Inputs added dynamically can be wired up by calling
 * `window.InputRestrictions.autoAttach(root)` after they are inserted, or
 * `attachName(el)` / `attachPhone(el)` / `attachEmail(el)` directly. The caret
 * position is preserved.
 */
(function () {
  'use strict';
  function filterValue(input, removeRe) {
    var before = input.value;
    var caret = input.selectionStart;
    var after = before.replace(removeRe, '');
    if (after === before) return;
    var removedBeforeCaret = before.slice(0, caret).replace(removeRe, '').length;
    input.value = after;
    try { input.setSelectionRange(removedBeforeCaret, removedBeforeCaret); } catch (e) {}
  }
  // Removes every '@' after the first occurrence, rather than stripping '@'
  // entirely — a single '@' is required for a valid email address.
  function filterExtraAtSigns(input) {
    var before = input.value;
    var caret = input.selectionStart;
    var firstAt = before.indexOf('@');
    if (firstAt === -1) return;
    var after = before.slice(0, firstAt + 1) + before.slice(firstAt + 1).replace(/@/g, '');
    if (after === before) return;
    var extraAtsBeforeCaret = Math.max(0, (before.slice(0, caret).match(/@/g) || []).length - 1);
    var newCaret = caret - extraAtsBeforeCaret;
    input.value = after;
    try { input.setSelectionRange(newCaret, newCaret); } catch (e) {}
  }
  var NAME_RE = /[0-9]/g;                 // names: strip digits
  var PHONE_RE = /[^0-9+()\s-]/g;          // phones: keep digits and + ( ) space -
  function attachName(el) { if (!el || el.dataset.irBound === '1') return; el.dataset.irBound = '1'; el.addEventListener('input', function () { filterValue(el, NAME_RE); }); }
  function attachPhone(el) { if (!el || el.dataset.irBound === '1') return; el.dataset.irBound = '1'; el.addEventListener('input', function () { filterValue(el, PHONE_RE); }); }
  function attachEmail(el) { if (!el || el.dataset.irBound === '1') return; el.dataset.irBound = '1'; el.addEventListener('input', function () { filterExtraAtSigns(el); }); }
  function autoAttach(root) {
    (root || document).querySelectorAll('[data-restrict="name"]').forEach(attachName);
    (root || document).querySelectorAll('[data-restrict="phone"]').forEach(attachPhone);
    (root || document).querySelectorAll('[data-restrict="email"]').forEach(attachEmail);
  }
  window.InputRestrictions = { attachName: attachName, attachPhone: attachPhone, attachEmail: attachEmail, autoAttach: autoAttach };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { autoAttach(document); });
  else autoAttach(document);
})();
